import { render, staticRenderFns } from "./simple-button.vue?vue&type=template&id=5edcaff2"
import script from "./simple-button.vue?vue&type=script&lang=js"
export * from "./simple-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edcaff2')) {
      api.createRecord('5edcaff2', component.options)
    } else {
      api.reload('5edcaff2', component.options)
    }
    module.hot.accept("./simple-button.vue?vue&type=template&id=5edcaff2", function () {
      api.rerender('5edcaff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/simple-button.vue"
export default component.exports